import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {

  public url: string;
  public token;
  public headers: HttpHeaders;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));

    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  create(token: any, task: any, users: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify(task));
    const json2 = encodeURIComponent(JSON.stringify(users));
    const params = `json=${json}&json2=${json2}&authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/reminder/new?page=${page}`, params, { headers })
      .pipe(map(res => res));
  }

  getContactsUser(token: any, page: any | null = 1, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this._http.post<any>(`${this.url}/reminder/list/${id}?page=${page}`, params, { headers })
      .pipe(map(res => res));
  }

  getContact(token: any, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const page = 1;

    return this._http.post<any>(`${this.url}/reminder/detail/${id}?page=${page}`, params, { headers })
      .pipe(map(res => res));
  }

  update(token: any, task: any, id: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/reminder/edit/${id}?page=${page}`, params, { headers })
      .pipe(map(res => res));
  }

  deleteContact(token: any, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    const page = 1;

    return this._http.post<any>(`${this.url}/reminder/remove/${id}?page=${page}`, params, { headers })
      .pipe(map(res => res));
  }

  getContactsUserLead(token, data, page = 1, perPage = 10, busqueda = "", filtros = [] ): Observable<any> {
    let url;

    url = `${this.url}/reminder/contactsuserlead?`

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(
      url,
      data
    );
  }

  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

}
